<!-- End Header -->
<main id="main">

    <!-- ======= Breadcrumbs ======= -->
    <!-- <section class="breadcrumbs">
        <div class="container">

            <div class="d-flex justify-content-between align-items-center">
                <h2>Products </h2>
                <ol>
                    <li><a href="index.html">Home</a></li>
                    <li>Products </li>
                </ol>
            </div>

        </div>
    </section> -->
    <!-- End Breadcrumbs -->
    <section class="login-page-section-top ">

        <div class="container">
            <div class="row">
                <div class="col-md-12 size-img back-img">
                    <div class="effect-cover">
                        <h3 class="txt-advert animated fadeInUp">Shop </h3>
                        <p class="txt-advert-sub animated">Looking for your perfect sports arsenal? Want some sizzling
                            sports gear? You have arrived at the right<br> place then.
                            Get all the perfect products from the sporting world at the best prices only on our E-store!
                        </p>

                    </div>
                </div>
            </div>
        </div>
        <div *ngFor="let banner of webBannerImageList" class="swiper-slide zoom-effect-container banner-image-div web-view-banner">
            <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
              <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="web banner" />
                <div class="slider-inner-div">
                  <div class="container">
                    <div class="main-heading-banner">
                      <div class="sldier-bottom-section"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngFor="let banner of mobileBannerImageList" class="swiper-slide zoom-effect-container banner-image-div mobile-view-banner">
            <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
              <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="mobile banner" />
                <div class="slider-inner-div">
                  <div class="container">
                    <div class="main-heading-banner">
                      <div class="sldier-bottom-section"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mobile_version-backbutton">
            <a class="mobile-header" onclick="history.back()">
              <i class="bx bx-chevron-left" style="color: #fff; font-size: 1.6em;"></i> Back </a>
          </div>


    </section>
    <!-- ======= Breadcrumbs ======= -->
    <div class="not-found-section d-none">
        <div class="col-md-12 not-found-body">
            <img src="assets/img/logo/not-found.gif" alt="">
            <h4>Coming Soon!</h4>
            <p>{{comingSoonMsg}}</p>

        </div>
    </div>
    <!-- ======= Product Section ======= -->
    <section class="team Product-section ">
        <div class=" container aos-init aos-animate" data-aos="fade-up">
            <div class="row">
                <div class="col-md-3 ">
                    <div class="left-side-section">
                        <div class="">
                            <div class="col-md-12 main-title p-p-0">
                                <h4> <span><i class='bx bx-filter-alt'></i></span> Filters</h4>
                            </div>
                            <div class=" price-range fliter-div pt-2">
                                <div class="col-md-12 p-p-0 filter-lable-title">
                                    <h6>Price Range</h6>
                                    <button pButton label="Clear Filter" title="Clear Filter"
                                        class="p-button p-ml-2 p-mb-2" (click)=" clear('price') "></button>
                                </div>

                                <!-- <div class="price-rangefeild d-flex">
                                    <ul>
                                        <li>
                                            <span class="currency">₹</span>
                                            <input type="number" class="form-control" placeholder="Min Price"
                                                value="1000">
                                        </li>
                                        <li>-</li>
                                        <li>
                                            <span class="currency">₹</span>
                                            <input type="number" class="form-control" placeholder="Max Price"
                                                value="10000">
                                        </li>
                                        <li><button (click)="PriceFilter()">Go</button></li>
                                    </ul>

                                </div> -->
                                <form [formGroup]="pricerangeform">
                                    <div class="price-rangefeild d-flex">
                                        <ul>
                                            <li>
                                                <span class="currency">₹</span>
                                                <input type="number" class="form-control" placeholder="Min Price"
                                                    formControlName="minvalue"
                                                    [ngClass]="{ 'is-invalid': productPriceSubmitted && productPrice.minvalue.errors?.invalidRange }">
                                            <li class="range-divider">-</li>
                                            <li class="smallrange-divider">
                                                <span>To</span>
                                            </li>
                                            <li>
                                                <span class="currency">₹</span>
                                                <input type="number" class="form-control" placeholder="Max Price"
                                                    formControlName="maxvalue"
                                                    [ngClass]="{ 'is-invalid': productPriceSubmitted && productPrice.maxvalue.errors?.invalidRange }">
                                            </li>
                                            <li
                                                [pTooltip]="(productPrice.minvalue.errors && !productPrice.minvalue.errors?.invalidRange) ? 'Enter min and max value' : ''">
                                                <button
                                                    [disabled]="(productPrice.minvalue.errors && !productPrice.minvalue.errors?.invalidRange)"
                                                    (click)="searchByPriceFilter()">Go</button>
                                            </li>
                                        </ul>
                                        <div
                                            *ngIf="productPriceSubmitted && productPrice.minvalue.errors?.invalidRange && productPrice.maxvalue.errors?.invalidRange">
                                            Min value cannot be greater than Max value
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <!-- <div class="fliter-div">

                            <div class="col-md-12 p-p-0">
                                <h6>Seller</h6>
                            </div>

                            <div class="sellers d-flex">
                                <div class="brand0lsit">
                                    <ul>
                                        <li *ngFor="let sellers of sellers">
                                            <img src={{sellers.sellerimg}} alt="" (click)="sellerlink()">
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="fliter-div Category-div">

                            <div class="col-md-12 p-p-0">
                                <h6>Category</h6>
                            </div>

                            <div class="Category d-flex">
                                <div class="Category-list">

                                    <ul>
                                        <li *ngFor="let categorys of categorys" (click)="CategoryFilter()">
                                            <span>{{categorys.productname}}</span><span
                                                class="badge">{{categorys.number}}</span>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div> -->

                    </div>
                </div>
                <div class="col-md-9">

                    <div class="row">
                        <div class="col-md-12 right-section-top-bar">
                            <div class="topleft">
                                <!-- <h5>Showing 1–{{products.length}} of {{totalRecords}} results</h5> -->

                                <div class="mobile-fliter-icon">
                                    <i class='bx bx-filter-alt' data-bs-toggle="modal"
                                        data-bs-target="#exampleModal"></i><span>Filter</span>
                                </div>
                            </div>
                            <!-- <div class="header-part "> -->
                               
                                <!-- <div class="short-by right-bar">
                                    <div class="default-shorting">
                                        <select class="form-select form-select-sm "
                                            aria-label=".form-select-sm example">
                                            <option selected>Default sorting</option>
                                            <option value="1">Sort by popularity</option>
                                            <option value="2">Sort by average rating</option>
                                            <option value="3">Sort by latest</option>
                                            <option value="4">Sort by price: low to high</option>
                                            <option value="5">Sort by price: high to low</option>
                                        </select>
                                    </div>

                                </div>
                                -->



                            <!-- </div> -->
                            <!-- <div class=" col-md-12 mobile-search-result">
                                <h5>Showing 1–5 of 5 results</h5>
                            </div> -->
                        </div>
                        <div class="col-md-4 col-sm-6" *ngFor="let product of products">
                            <div class="member aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                <div class="product-body">
                                    <div class="member-img">
                                        <div class="swiper shop">
                                            <swiper class="swiper-wrapper" fxFlex="auto" [config]="product_config"
                                                [disabled]="disabled" (indexChange)="onIndexChange($event)"
                                                (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                                                (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                                                <div class="swiper-slide product-image-slider-div">
                                                    <img src="{{product.productImage[0]['image_src']}}" class="img-fluid"
                                                        alt="">
                                                </div>
    
    
    
    
                                            </swiper>
                                            <!-- <div class="swiper-button-next"></div>
                                            <div class="swiper-button-prev"></div> -->
                                            <!-- <div class="swiper-pagination"></div> -->
                                        </div>
    
                                    </div>
                                    <div class="member-info">
                                        <h4>{{product.name}}</h4>
                                        <span class="price"><i class="bx bx-rupee"></i>{{product.price['$numberDecimal']}}</span>
                                    </div>
                                    <div class="brand-logo">
                                        <div class="media">
                                            <div class="media-body">
                                                <span class="sellerspan">Seller: </span>
                                                <span><img src="{{product.product_logo}}" alt="" class="brand-img"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <a href="{{product.affiliateurl}}" target="_blank"><button class="add-to-cart"> Buy
                                                Now <span><i class='bx bx-cart'></i></span>
                                            </button></a>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <!-- <div class="col-md-4 col-sm-6">
                            <div class="member aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                <div class="member-img">
                                    <img src="assets/img/Product/dress/511iDNJnBeL._UX569_.jpg" class="img-fluid"
                                        alt="">

                                </div>
                                <div class="member-info">
                                    <h4> Women’s Apparel </h4>
                                    <span class="price">₹168.00</span>
                                </div>
                                <div class="brand-logo">
                                    <div class="media">
                                        <div class="media-body">
                                            <span class="sellerspan">Seller: </span>
                                            <span><img src="assets/img/brands-logo/flipkart-logo.png" alt=""
                                                    class="brand-img"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="add-to-cart"> Buy Now <span><i class='bx bx-cart'></i></span>
                                    </button>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6 ">
                            <div class="member aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                <div class="member-img">
                                    <div class="swiper shop">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide">
                                                <img src="assets/img/Product/ball/product3.jpg" class="img-fluid"
                                                    alt="">
                                            </div>
                                            <div class="swiper-slide">
                                                <img src="assets/img/Product/ball/product2.jpg" class="img-fluid"
                                                    alt="">
                                            </div>
                                            <div class="swiper-slide">
                                                <img src="assets/img/Product/ball/product1.jpg" class="img-fluid"
                                                    alt="">
                                            </div>


                                        </div>
                                        <div class="swiper-button-next"></div>
                                        <div class="swiper-button-prev"></div>
                                        <div class="swiper-pagination"></div>
                                    </div>

                                </div>
                                <div class="member-info">
                                    <h4>Tennis Balls</h4>
                                    <span class="price">₹168.00</span>
                                </div>
                                <div class="brand-logo">
                                    <div class="media">
                                        <div class="media-body">
                                            <span class="sellerspan">Seller: </span>
                                            <span><img src="assets/img/brands-logo/amazon-black-logo.png" alt=""
                                                    class="brand-img"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="add-to-cart"> Buy Now <span><i class='bx bx-cart'></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="member aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                <div class="member-img">
                                    <div class="swiper shop">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide">
                                                <img src="assets/img/Product/tennis/product1.jpg" class="img-fluid"
                                                    alt="">
                                            </div>
                                            <div class="swiper-slide">
                                                <img src="assets/img/Product/tennis/product7.jpg" class="img-fluid"
                                                    alt="">
                                            </div>
                                            <div class="swiper-slide">
                                                <img src="assets/img/Product/tennis/product3.jpg" class="img-fluid"
                                                    alt="">
                                            </div>
                                            <div class="swiper-slide">
                                                <img src="assets/img/Product/tennis/product5.jpg" class="img-fluid"
                                                    alt="">
                                            </div>
                                        </div>
                                        <div class="swiper-button-next"></div>
                                        <div class="swiper-button-prev"></div>
                                        <div class="swiper-pagination"></div>
                                    </div>

                                </div>
                                <div class="member-info">
                                    <h4>Tennis Racquets</h4>
                                    <span class="price">₹168.00</span>
                                </div>
                                <div class="brand-logo">
                                    <div class="media">
                                        <div class="media-body">
                                            <span class="sellerspan">Seller: </span>
                                            <span><img src="assets/img/brands-logo/meesho-logo.png" alt=""
                                                    class=" brand-img"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="add-to-cart"> Buy Now <span><i class='bx bx-cart'></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="member aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                <div class="member-img">
                                    <div class="swiper shop">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide">
                                                <img src="assets/img/Product/shoes/product2.jpg" class="img-fluid"
                                                    alt="">
                                            </div>
                                            <div class="swiper-slide">
                                                <img src="assets/img/Product/shoes/product1.jpg" class="img-fluid"
                                                    alt="">
                                            </div>

                                        </div>
                                        <div class="swiper-button-next"></div>
                                        <div class="swiper-button-prev"></div>
                                        <div class="swiper-pagination"></div>
                                    </div>


                                </div>
                                <div class="member-info">
                                    <h4>Tennis Shoes</h4>
                                    <span class="price">₹168.00</span>
                                </div>
                                <div class="brand-logo">
                                    <div class="media">
                                        <div class="media-body">
                                            <span class="sellerspan">Seller: </span>
                                            <span><img src="assets/img/brands-logo/amazon-black-logo.png" alt=""
                                                    class="brand-img"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="add-to-cart"> Buy Now <span><i class='bx bx-cart'></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4  col-sm-6">
                            <div class="member aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                <div class="member-img">
                                    <img src="assets/img/Product/grip/product1.jpg" class="img-fluid" alt="">

                                </div>
                                <div class="member-info">
                                    <h4>Tennis Grip</h4>
                                    <span class="price">₹168.00</span>
                                </div>
                                <div class="brand-logo">
                                    <div class="media">
                                        <div class="media-body">
                                            <span class="sellerspan">Seller: </span>
                                            <span><img src="assets/img/brands-logo/AliExpress-logo.png" alt=""
                                                    class="brand-img"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="add-to-cart"> Buy Now <span><i class='bx bx-cart'></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6 ">
                            <div class="member aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                <div class="member-img">
                                    <img src="assets/img/Product/string/multi-filament.jpg" class="img-fluid" alt="">

                                </div>
                                <div class="member-info">
                                    <h4>Tennis Strings</h4>
                                    <span class="price">₹168.00</span>
                                </div>
                                <div class="brand-logo">
                                    <div class="media">
                                        <div class="media-body">
                                            <span class="sellerspan">Seller: </span>
                                            <span><img src="assets/img/brands-logo/EBay_logo.png" alt=""
                                                    class="brand-img"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="add-to-cart"> Buy Now <span><i class='bx bx-cart'></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="member aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                <div class="member-img">
                                    <img src="assets/img/Product/prod2.jpg" class="img-fluid" alt="">

                                </div>
                                <div class="member-info">
                                    <h4>Black Kit Bags</h4>
                                    <span class="price">₹168.00</span>
                                </div>
                                <div class="brand-logo">
                                    <div class="media">
                                        <div class="media-body">
                                            <span class="sellerspan">Seller: </span>
                                            <span><img src="assets/img/brands-logo/snapdeal-.png" alt=""
                                                    class="brand-img"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="add-to-cart"> Buy Now <span><i class='bx bx-cart'></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6 hide-mobile-product ">
                            <div class="member aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                <div class="member-img">
                                    <img src="assets/img/Product/prod4.jpg" class="img-fluid" alt="">

                                </div>
                                <div class="member-info">
                                    <h4>Blue Kit Bags</h4>
                                    <span class="price">₹168.00</span>
                                </div>
                                <div class="brand-logo">
                                    <div class="media">
                                        <div class="media-body">
                                            <span class="sellerspan">Seller: </span>
                                            <span><img src="assets/img/brands-logo/Shopclues.png" alt=""
                                                    class="brand-img"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="add-to-cart"> Buy Now <span><i class='bx bx-cart'></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <nav aria-label="Page navigation example">
                                <ul class="pagination justify-content-center mt-3">
                                    <li class="page-item"><a class="page-link " href="#">Previous</a></li>
                                    <li class="page-item"><a class="page-link active" href="#">1</a></li>
                                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                                    <li class="page-item"><a class="page-link" href="#">Next</a></li>
                                </ul>
                            </nav>
                        </div> -->
                    </div>
                    <!-- <div class="col-md-12">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination justify-content-center mt-3">
                                <li class="page-item"><a class="page-link " href="#">Previous</a></li>
                                <li class="page-item"><a class="page-link active" href="#">1</a></li>
                                <li class="page-item"><a class="page-link" href="#">2</a></li>
                                <li class="page-item"><a class="page-link" href="#">3</a></li>
                                <li class="page-item"><a class="page-link" href="#">Next</a></li>
                            </ul>
                        </nav>
                    </div> -->
                    <div class="contest-pagination">
                        <div class="p-d-flex p-ai-center p-jc-between">
                            In total there are
                            {{totalRecords }} Products.
                        </div>
                        <div class="pagination-div">
                            <p-paginator *ngIf="totalRecords > 0" [rows]="10" #paginator  class="paginater" pageLinkSize="3"
                                [totalRecords]="totalRecords" (onPageChange)="loadProducts($event, mode)"
                                [rowsPerPageOptions]=" pagination"></p-paginator>
                        </div>
                        <div *ngIf="totalRecords == 0">
                            <span>
                                There is no Products available.
                            </span>
                        </div>
                    </div>
                    <!-- <p-paginator *ngIf="totalRecords > 0" [rows]="9" #paginator [totalRecords]="totalRecords"
                        (onPageChange)="loadProducts($event)" [rowsPerPageOptions]=" pagination"></p-paginator>
                    <div *ngIf="totalRecords == 0">
                        <span>
                            There is no Products available.
                        </span>
                    </div> -->
                </div>



            </div>
        </div>
    </section>
    <!-- End Product -->

    <!--Modal --->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="col-md-12 main-title">
                        <h4> <span><i class='bx bx-filter-alt'></i></span> Filters</h4>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="left-side-section" style="box-shadow: none;">
                        <div class="">
                            <div class=" price-range fliter-div pt-2">
                                <div class="col-md-12 p-p-0 filter-lable-title">
                                    <h6 style="font-weight: normal;">Price Range</h6>
                                   
                                </div>

                                <!-- <div class="price-rangefeild d-flex">
                                    <ul>
                                        <li>
                                            <span class="currency">₹</span>
                                            <input type="number" class="form-control" placeholder="Min Price"
                                                value="1000">
                                        </li>
                                        <li>-</li>
                                        <li>
                                            <span class="currency">₹</span>
                                            <input type="number" class="form-control" placeholder="Max Price"
                                                value="10000">
                                        </li>
                                        <li><button (click)="PriceFilter()">Go</button></li>
                                    </ul>

                                </div> -->
                                <form [formGroup]="pricerangeform">
                                    <div class="price-rangefeild d-flex">
                                        <ul>
                                            <li>
                                                <span class="currency">₹</span>
                                                <input type="number" class="form-control" placeholder="Min Price"
                                                    formControlName="minvalue"
                                                    [ngClass]="{ 'is-invalid': productPriceSubmitted && productPrice.minvalue.errors?.invalidRange }">
                                            <li class="range-divider">-</li>
                                            <li class="smallrange-divider">
                                                <span>To</span>
                                            </li>
                                            <li>
                                                <span class="currency">₹</span>
                                                <input type="number" class="form-control" placeholder="Max Price"
                                                    formControlName="maxvalue"
                                                    [ngClass]="{ 'is-invalid': productPriceSubmitted && productPrice.maxvalue.errors?.invalidRange }">
                                            </li>
                                            <li
                                                [pTooltip]="(productPrice.minvalue.errors && !productPrice.minvalue.errors?.invalidRange) ? 'Enter min and max value' : ''">
                                                <button
                                                    [disabled]="(productPrice.minvalue.errors && !productPrice.minvalue.errors?.invalidRange)"
                                                    (click)="searchByPriceFilter()">Go</button>
                                            </li>
                                        </ul>
                                        <div
                                            *ngIf="productPriceSubmitted && productPrice.minvalue.errors?.invalidRange && productPrice.maxvalue.errors?.invalidRange">
                                            Min value cannot be greater than Max value
                                        </div>
                                    </div>
                                </form>
                            </div>
                        
                        </div>

                    </div>
                </div>
                <div class="modal-footer filter-button">
                    <button type="button" class="btn btn-secondary" (click)=" clear('price') "  data-bs-dismiss="modal">Clear All</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Apply</button>
                </div>
            </div>
        </div>
    </div>

</main><!-- End #main -->